import { Button } from '@Utilities/Button';
import { CartService } from "@Api/CartService";
import type { AxiosResponse } from "axios";
import BootstrapModalTemplate from "@Base/Templates/BootstrapModal.hbs";
import { IBootstrapModal, ModalTools } from "./ModalTools";
import { TextResource } from './TextResource';

export interface ICartCallback
{
	(cartProduct: ICartProduct): void;
}

export interface ICartProduct
{
	Price?: number,
	ProductID: string;
	ProductSizeID: string;
	ProductSku?: string;
	Quantity: number;
	CartItemOriginID: string;
}

export class Cart
{
	private readonly cartService: CartService;

	constructor()
	{
		this.cartService = new CartService();
	}

	public AddPreOrder = (form: HTMLFormElement): void =>
	{
		// Preorder doesn't use api
		if (form !== null && typeof form !== "undefined")
		{
			if (typeof form.submit !== "undefined")
			{
				form.submit();
			}
		}
	};

	public AddProduct = async (product: ICartProduct, callback?: ICartCallback): Promise<void> =>
	{
		const cartApiCall = await this.cartService.AddProduct(product) as AxiosResponse;

		if (typeof cartApiCall !== "undefined" && typeof cartApiCall.data !== "undefined")
		{
			this.AddProductCallback("new", cartApiCall.data, product, callback);
		}
	};

	private AddProductCallback = async (type: string, msg, product: ICartProduct, callback?: ICartCallback): Promise<void> =>
	{
		const productSizeID = product.ProductSizeID;
		const atcPageUrl = `/product/addtocart/${productSizeID}`;

		Button.StopLoading();

		if ((msg.Error && msg.Error.length > 0) || (msg.Warning && msg.Warning.length > 0))
		{
			if (msg.Error.some((x) => x.Type === 115))
			{
				const modalOptions: IBootstrapModal = {
					modalId: "overSoldModal",
					modalContent: msg.Error[0].Description,
					confirmButton: TextResource.GetTextByCulture("Word_Continue"),
					displayButtons: true
				};

				const modal = BootstrapModalTemplate(modalOptions);
				ModalTools.DisplayGeneratedModal(modal);

				const injectedModal = document.querySelector("#overSoldModal");

				if (injectedModal !== null)
				{
					injectedModal.querySelector(".btn-primary").addEventListener("click", () =>
					{
						window.location.href = atcPageUrl;
					});
				}
			}
			else
			{
				ModalTools.DisplayMessages(msg);
			}
		}
		else
		{
			if (callback && typeof callback === "function")
			{
				callback(product);
			}
			else
			{
				window.location.href = atcPageUrl;
			}
		}
	};
}